module.exports = __webpack_public_path__ + "static/media/C2.703f122d.jpg";